import * as React from "react";
import {
  container,
  logo,
  branding,
  menuWrapper,
  hamburgerIcon,
  secondaryContainer,
  link,
  menuContainer,
  mobilMenu,
  openMenu,
  styledRow,
} from "./Header.module.scss";
import { Row } from "react-bootstrap";
import { Link } from "gatsby";
import { Storage } from "../../../utils/storage";
import { Constants } from "../../../@types/Constants";

export const NavigationContainer: React.FC<any> = (props) => {
  return (
    <nav
      className={`${container} ${
        props.menuOpen ? "override-fixed-navbar" : ""
      }`}
    >
      {props.children}
    </nav>
  );
};
export const Logo: React.FC = () => {
  return (
    <svg className={logo}>
      <use xlinkHref="/svg/sonesta_internations_logo.svg#SonestaInternationalHotels_Logo"></use>
    </svg>
  );
};
export const StyledRow: React.FC<any> = (props) => {
  return (
    <Row className={`${props.className} ${styledRow} header-row`}>
      {props.children}
    </Row>
  );
};
export const Nav: React.FC<any> = (props) => {
  return <nav className={container}>{props.children}</nav>;
};
export const Branding: React.FC<any> = (props) => {
  return <div className={branding}>{props.children}</div>;
};
export const HamburgerIcon: React.FC<any> = (props) => {
  return (
    <div className={props.menuOpen ? openMenu : hamburgerIcon}>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
    </div>
  );
};
export const PrimaryMenu: React.FC<any> = (props) => {
  return (
    <>
      <nav className={menuWrapper} role="navigation">
        <span className="visually-hidden">Main Navigation</span>
        <a
          id={"mobile-trigger"}
          className="d-block d-lg-none mt-2"
          href={`#`}
          title={"Menu"}
          aria-label="Menu"
        >
          {/* <HamburgerIcon {...props} /> */}
        </a>

        <MenuContainer {...props}>
          <MenuItem
            to="/our-brands"
            title="Our Brands"
            id="our-brands-header"
          />
          <MenuItem
            to="/offers"
            title="Special Offers"
            id="special-offers-header"
          />
          <MenuItem
            to="https://events.sonesta.com"
            target="_blank"
            title="Meetings &amp; Events"
            id="meetings-events-header"
          />
        </MenuContainer>
      </nav>
    </>
  );
};
export const Menu: React.FC<any> = (props) => {
  return (
    <>
      <nav className={menuWrapper} role="navigation">
        <span className="visually-hidden">Main Navigation</span>
        <a
          id={"mobile-trigger"}
          className="d-block d-lg-none"
          href={`#`}
          title={"Menu"}
          onClick={props.handleMenuOpen}
          aria-label="Menu"
        >
          <HamburgerIcon {...props} />
        </a>
        {props.menuOpen ? (
          <MenuContainer {...props}>
            <MenuItem to="/our-brands" title="Our Brands" />
            <MenuItem to="/offers" title="Special Offers" />
            <MenuItem
              to="https://events.sonesta.com"
              target="_blank"
              title="Meetings &amp; Events"
            />
            <MenuItem
              to={props.isLoggedIn ? "/account" : "/manage-reservation"}
              title="My Stays"
            />
            <MenuItem to="/support" title="Help" />
          </MenuContainer>
        ) : null}
      </nav>
    </>
  );
};

export const SecondaryMenu: React.FC<any> = (props) => {
  return (
    <>
      <nav className={menuWrapper} role="navigation">
        <span className="visually-hidden">Secondary Navigation</span>
        <MenuContainer className={secondaryContainer} {...props}>
          <MenuItem
            id="manage-reservations"
            to={props.isLoggedIn ? "/account" : "/manage-reservation"}
            title="My Stays"
          />
          <MenuItem id="help" to="/support" title="Help" />
        </MenuContainer>
      </nav>
    </>
  );
};
export const MenuItem: React.FC<any> = (props) => {
  const ClearBrandBias = () => {
    Storage.ClearLocalStorageValue(Constants.BRAND_BIAS_KEY);
  };
  return (
    <li className={`${props.isHidden ? "mobile" : ""}`}>
      <Link
        onClick={ClearBrandBias}
        id={props.id}
        to={props.to}
        className={link}
        target={props.target ? props.target : ""}
        activeClassName={`active`}
      >
        {props.title}
      </Link>
    </li>
  );
};
export const MenuContainer: React.FC<any> = (props) => {
  return (
    <ul
      className={`${props.isMobileOnly ? mobilMenu : menuContainer}  ${
        props.className ? props.className : ""
      }`}
    >
      {props.children}
    </ul>
  );
};
